import React from 'react';

import TypographyLink, { type TypographyLinkProps } from '@fmbt/ui/TypographyLink';

type Props = Pick<TypographyLinkProps, 'customColor'> & {
  phoneNumber: string;
  id?: string;
  label?: string;
};

/**
 * Creates a tel link based on a phone number.
 */
function AnchorTel({
  phoneNumber,
  label,
  ...rest
}: Props): JSX.Element {
  return (
    <TypographyLink
      {...rest}
      href={`tel:${phoneNumber}`}
      underline
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      {label || phoneNumber}
    </TypographyLink>
  );
}

export default AnchorTel;
